import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import TrackerDashboard from '../../../HabitsHub/TrackerDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { fetchCompanyHabitsDashboard } from './companyHabitsApi';

/**
 * Company Habits → Tracker Dashboard, scoped to this company's employees or
 * members (per the sidebar B2B/Members toggle). Recreating the fetcher when
 * the toggle flips makes the shared dashboard refetch with the new scope.
 */
const CHabitsTracker = () => {
  const { isB2BFansMode } = useContext(SidebarContext);

  const fetcher = useCallback(
    () => fetchCompanyHabitsDashboard(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Habit Tracker | Shoorah</title>
      </Helmet>
      <TrackerDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CHabitsTracker;
